
export class UserActivityDashboardList {
   

    createdAt: Date;
    description: string;
    username: string;
    email: string;
    wpassId: string;
    constructor( username:string, createdAt: Date, description: string,
        email: string, wpassId: string){
        this.username = username;
        this.createdAt = createdAt;
        this.description = description;
        this.email = email;
        this.wpassId = wpassId;
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-activity-logs/user-activity-datatable/user-activity-dashboardList.ts